mutation SendTestEmailTemplate($id: ID!, $language: MarketingLanguage!) {
  sendTestEmailTemplate(id: $id, language: $language)
}
